-
<template>
	<div class="centerWidth">
		<div class="gaokao">
			<div class="gaokao-nav">
				<span @click="goMyCenter">个人中心 ></span>
				<span>填：录取风险评估</span>
			</div>
			<section class="gaokao-content">
				<article class="yuan_top">
					<div class="yuan_head">
						<div class="yuan_tab zhong flex">
							<label>目标大学：</label>
							<div class="way-test" style="width: 200px;">
								<div class="share-li" style="width: 100%;">
									<img src="../../../image/search.png" />
									<input v-model="Name" placeholder="请输入内容"
										style="width: 100%; padding-left: 40px;" />
								</div>
							</div>
							<el-select v-model="cityName" placeholder="请选择" class="yuanXz">
								<el-option v-for="item in cityList" :key="item.Code" :label="item.Name"
									:value="item.Code"></el-option>
							</el-select>
							<el-select v-model="value" placeholder="请选择" class="yuanXz">
								<el-option v-for="item in options" :key="item.value" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<div class="major-share-con">
							<div class="share-li" style="width: auto;">
								<p>参考分数:</p>
								<input v-model="Score" type="number" placeholder="请输入" style="width: 164px;" />
							</div>
							<div class="major-btn01"><button class="gaokao-btn" @click="selectlist()">开始测试</button>
							</div>
						</div>
					</div>
					<div class="yuan_head_hg float">
						<img src="../../../image/ts.png" />
						<hgroup>
							<h6>大学录取风险评估查询说明</h6>
							<p style="font-size: 16px;color: #333;">透过大数据，为您支招志愿填报。</p>
							<p>录取风险评估系统的结果是根据该校历年录取分数线计算得出的结论，仅供参考;</p>
						</hgroup>
					</div>
				</article>

				<article class="yuanList">
					<ul>
						<li v-for="(item, index) in list" :key="index">
							<div class="list_head zhong float">
								<div class="list_head_flex">
									<div class="list-four">
										<h6>{{ item.CollegesName }}</h6>
									</div>
									<div class="list-four">
										<hgroup class="flex zhong">
											<p>
												院校代码:
												<span>{{ item.CollegesCode }}</span>
											</p>
											<i v-if="item.TypeId == 1">可冲击</i>
											<i v-else-if="item.TypeId == 2"
												style="background-color: #ffe3be;color: #f59a23;">较稳定</i>
											<i v-else-if="item.TypeId == 3"
												style="background-color: #ccedc6;color: #63be52;">保底</i>
											<i v-else-if="item.TypeId == 4"
												style="background-color: #ccedc6;color: #63be52;">风险大</i>
										</hgroup>
									</div>
								</div>
								<div class="list-four">
									<p style="text-align: right;">
										招生计划:
										<span>{{ item.EnrollmentPlan }}</span>
									</p>
								</div>
							</div>

							<div class="listTxt">
								<p>
									招生地区：
									<span>{{ item.EnrollmentArea }}</span>
								</p>
								<p>
									考生类别：
									<span>{{ item.CandidatesType }}</span>
								</p>
								<p>
									平均分：
									<span>{{ item.Average }}</span>
								</p>
								<p>
									最低分：
									<span>{{ item.LowestScore }}</span>
								</p>
								<p>
									最低位次：
									<span>{{ item.LowestOrder }}</span>
								</p>
							</div>
							<p class="beiTxt">
								<span>备注：{{ item.Remarks }}</span>
							</p>
						</li>
					</ul>
				</article>

				<div class="flex xend major-page" style="margin: 20px auto;" v-if="list.length > 0">
					<el-pagination background layout="prev, pager, next" :page-size="size" @current-change="GetPageList"
						:current-page="page" :total="totleNum"></el-pagination>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	import 'vue-area-linkage/dist/index.css';
	import {
		pca,
		pcaa
	} from 'area-data';
	import {
		mapState
	} from 'vuex';
	export default {
		data() {
			return {
				options: [{
						value: '不分文理',
						label: '不分文理'
					},
					{
						value: '文科',
						label: '文科或选历史'
					},
					{
						value: '理科',
						label: '理科或选物理'
					}
				],
				value: '',
				pca: pca,
				pcaa: pcaa,
				Name: '',
				Score: '',
				page: 1,
				size: 10,
				totleNum: 0,
				selected2: [],
				cityList: [],
				cityName: '',
				list: []
			};
		},
		computed: {
			...mapState(['user', 'shop'])
		},
		watch: {
			'shop.currentProvince': {
				handler(newVal) {
					this.cityList = newVal;
				}
			}
		},
		// 加载
		created() {
			this.$store.state.shop.currentProvince.map(ent => {
				if (ent.Code === this.$store.state.user.user.ProvinceCode.toString()) {
					this.cityList.push(ent);
				}
			});

			if (this.cityList.length > 0) {
				this.cityName = this.cityList[0].Code;
			}
			if (this.$route.query.key) {
				this.$api.reduceUserCount({
					key: this.$route.query.key
				});
			} else {
				this.$router.back(-1);
			}
		},
		methods: {
			// 个人中心
			goMyCenter() {
				this.$router.push('/myIndex');
			},

			selectlist() {
				if (this.cityName === '') {
					this.$util.showError('请选择招生地区');
					return;
				}
				if (this.Score === '') {
					this.$util.showError('请输入分数');
					return;
				}
				this.AdmissionRiskAssessment(1);
			},
			AdmissionRiskAssessment(page) {
				var that = this;

				var data = {
					page: page,
					size: 10,
					cityCode: that.cityName,
					candidatesType: that.value,
					score: that.Score,
					name: that.Name
				};
				console.log(data);
				that.$api.HtppRequest(
					'SystemData/AdmissionRiskAssessment',
					'POST',
					data,
					function(res) {
						console.log('获取列表', res);

						if (res.flag && res.totle > 0) {
							var list = res.list;

							that.totleNum = res.totle;

							if (page === 1) {
								that.list = [];
							}
							if (list.length > 0) {
								that.page = page;
								for (var i = 0; i < list.length; i++) {
									that.list.push(list[i]);
								}
							}

							console.log(that.list);
						} else {
							console.log('错误：' + page);
							if (page === 1) {
								that.list = [];
								that.$util.showError('暂无可用院校');
							}
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			// 获取其他页
			GetPageList: function(val) {
				var that = this;
				that.AdmissionRiskAssessment(val);
			}
		}
	};
</script>

<style scoped>
	.beiTxt span {
		color: #999;
	}

	.beiTxt {
		font-size: 14px;
		color: #333;
		margin-top: 10px;
	}

	.list-four p {
		font-size: 14px;
	}

	.list_head_flex .list-four:first-child {
		width: 28%;
	}

	.list_head_flex {
		overflow: hidden;
		display: flex;
		width: 72%;
	}

	.listTxt p:nth-child(n + 3) {
		text-align: center;
	}

	.listTxt p:last-child {
		text-align: right;
	}

	.listTxt p span {
		color: #333;
	}

	.listTxt p {
		width: 20%;
		float: left;
		font-size: 14px;
		color: #999;
	}

	.listTxt {
		margin-top: 30px;
		overflow: hidden;
	}

	.list-four hgroup i {
		width: 74px;
		height: 30px;
		border-radius: 4px;
		line-height: 30px;
		text-align: center;
		display: block;
		background-color: #fdc6c3;
		color: #ff3327;
		font-style: normal;
		margin-left: 2em;
		font-size: 14px;
	}

	.list-four hgroup p span {
		color: #333;
		margin-left: 6px;
		margin-right: 6px;
	}

	.list-four hgroup p {
		font-size: 14px;
		color: #999999;
	}

	.list-four h6 {
		font-size: 16px;
		color: #fff;
		border-radius: 50px;
		background-color: #333;
		min-width: 120px;
		text-align: center;
		padding: 0 15px;
		display: inline-block;
		font-weight: normal;
		height: 35px;
		line-height: 35px;
	}

	.list_head {
		overflow: hidden;
		display: flex;
	}

	.yuanList li {
		padding: 30px;
		background-color: #fff;
		border: solid 1px #e6e6e6;
		margin-top: 20px;
	}

	.yuanList {
		overflow: hidden;
	}

	.share-li {
		position: relative;
	}

	.share-li>img {
		display: block;
		width: 20px;
		height: 20px;
		position: absolute;
		left: 10px;
		top: 50%;
		margin-top: -10px;
		z-index: 1;
	}

	/* tabTop */

	.yuan_head_hg p {
		font-size: 14px;
		color: #666666;
		margin-top: 10px;
	}

	.yuan_head_hg h6 {
		font-size: 14px;
		color: #f59a23;
		line-height: 22px;
		margin-bottom: 10px;
	}

	.yuan_head_hg hgroup {
		width: calc(100% - 30px);
	}

	.yuan_head_hg img {
		display: block;
		width: 22px;
		height: 22px;
	}

	.yuan_head_hg {
		padding: 15px 30px;
		display: flex;
	}

	/* yuan_head_hg */

	*>>>.area-select .area-selected-trigger {
		color: #b7b7b7;
		line-height: 24px;
	}

	.yuan_tab {
		width: 85%;
	}

	*>>>.cascader-menu-list .cascader-menu-option.selected {
		color: #333 !important;
	}

	*>>>.area-select.large {
		width: 100%;
		height: 40px;
		box-sizing: border-box;
	}

	.way-test,
	.yuanXz {
		width: 146px;
		height: 40px;
		margin-left: 20px;
	}

	.major-share-con {
		width: 45%;
		height: auto;
		overflow: ;
		display: flex;
		flex-wrap: wrap;
	}

	.share-li {
		width: 50%;
		display: flex;
		align-items: center;
		/* justify-content: center; */
		margin: 10px 0;
	}

	.share-li p {
		font-size: 14px;
		color: #333;
		width: 100px;
		text-align: right;
		margin-right: 20px;
	}

	.share-li input {
		width: 270px;
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		display: block;
		border-radius: 5px;
		background-color: #fff;
		color: #333;
		font-size: 14px;
	}

	.share-li input::-webkit-input-placeholder {
		color: #999;
	}

	.share-li input:-moz-placeholder {
		color: #999;
	}

	.share-li input:-ms-input-placeholder {
		color: #999;
	}

	.sjWidth {
		width: 270px;
	}

	.major-btn01 {
		width: 18%;
		display: flex;
		align-items: flex-end;
		margin-left: 20px;
	}

	.major-btn01 button {
		margin: 0px auto;
		width: 90px;
		font-size: 14px;
		margin-left: 0 !important;
		float: right;
	}

	.yuan_tab label {
		font-size: 14px;
		color: #333;
	}

	.yuan_head {
		padding: 0 36px;
		border-bottom: solid 2px #333;
		display: flex;
		padding-bottom: 36px;
	}

	.yuan_top {
		background-color: #eaeaea;
		padding: 36px 0;
		margin: 36px 0 0 0;
	}

	/* yuan_top */

	.gaokao {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.gaokao-nav {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.gaokao-nav span {
		font-size: 15px;
		color: #333;
	}

	.gaokao-nav span:last-child {
		color: #333;
	}

	/* gaokao-content */
	.gaokao-content {
		padding: 0 20px;
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #fff;
		margin-bottom: 25px;
	}

	.gaokao-con {
		padding: 50px 20px;
		height: auto;
		overflow: hidden;
	}

	.gaokao-con p {
		font-size: 14px;
		color: #333;
		text-indent: 2em;
		line-height: 28px;
	}

	/* gaokao-notice */
	.gaokao-notice {
		width: 100%;
		padding: 0 40px 40px 40px;
		height: auto;
		overflow: hidden;
		background-color: #eee;
	}

	.gk-notice-tit {
		font-size: 17px;
		color: #333;
		padding: 40px 0;
	}

	.gk-notice-li {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.gk-notice-li li {
		font-size: 15px;
		color: #333;
		padding-bottom: 15px;
	}

	.gk-notice-li li:last-child {
		padding-bottom: 0px;
	}

	.gaokao-btn {
		width: 200px;
		height: 40px;
		background-color: #333;
		border-radius: 6px;
		font-size: 16px;
		color: #fff;
		line-height: 40px;
		margin: 50px auto;
		display: block;
	}
</style>
